var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.89,3H3.11l-1,1V20l1,1H20.89l1-1V4l-1-1ZM4.11,5h15.78v2H4.11v-2Zm6.89,14H4.11v-4h6.89v4Zm0-6H4.11v-4h6.89v4Zm8.89,6h-6.89v-4h6.89v4Zm0-6h-6.89v-4h6.89v4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTable);
export default __webpack_public_path__ + "static/1769707387/media/icon-table.eb784e2ed19e884e2ef29a412ae6eae4.svg";
export { ForwardRef as ReactComponent };